<template>

	<section>
		
        <iframe :src="fileToDisplay" style="width:100%; height:40vh" frameborder="0"></iframe>

	</section>

</template>

<script>

export default {

	props: ['fileToDisplay']

};

</script>



// WEBPACK FOOTER //
// src/components/File/FileIframe.vue